export default __webpack_public_path__ + "static/b-card-visual-hierachy-5d1ccb0081164d52828d502d5ce16de4.jpg";